/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	AdditionalQuestionStorePathParams,
	AdditionalQuestionStoreRequest,
	AdditionalQuestionStoreResponse,
} from '../types/AdditionalQuestionStore'

/**
 * POST /forms/:form/additional-questions
 * @see backend/nexus/modules/Form/Http/Controllers/AdditionalQuestionController.php AdditionalQuestionController::store
 */
export async function additionalQuestionStore(
	form: AdditionalQuestionStorePathParams['form'],
	data: AdditionalQuestionStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AdditionalQuestionStoreResponse>> {
	return axiosInstance.post(`/forms/${form}/additional-questions`, data, config)
}
